import '../scss/style.scss'

import 'swiper/swiper-bundle.css';
import 'glightbox/dist/css/glightbox.css'

import GLightbox from 'glightbox';

import Scroll from './scroll'
import Nav from './nav'
import Search from './search';
import QuoteCarousel from './quote_carousel';
import Router from './router'
import CompaniesCarousel from './companies_carousel';

import SubsectionNavigation from './subsection_navigation';
import Animations from './animations';
import Transcript from './transcript';
import NewsFilter from './news-filter';

var routes = {
  // JavaScript to be fired on all pages
  common: (context) => {
    // console.log("Common", context);
    Transcript(jQuery, context).init()
    Scroll(jQuery, context).init()
    Search(jQuery, context).init()
    Nav(jQuery, context).init()
    QuoteCarousel(jQuery, context).init()
    NewsFilter(jQuery, context).init()
    CompaniesCarousel(jQuery, context).init()
    GLightbox({selector: 'a[data-video-lightbox="true"]'});
    SubsectionNavigation(jQuery, context).init()
    Animations(jQuery, context,
      (newContainerContext) => {
        initializeRouter(newContainerContext)
      }
    ).init()
  },
  home: (context) => {
  },
}

const initializeRouter = (context) => {
  Router(jQuery, context).init(routes);
}

jQuery( () => {
  // console.log("INIT")
  initializeRouter('.barba-wrapper')
})
